import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Inquiry } from 'verify/models/inquiry';

export interface VerifyWithPersonaState {
  nextInquiry: Inquiry;
}

const initialState: VerifyWithPersonaState = {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  nextInquiry: null,
};

interface SetNextInquiryPayload {
  inquiry: Inquiry;
}

const { reducer, actions } = createSlice({
  name: 'verify-with-persona',
  initialState,
  reducers: {
    setNextInquiry: (state, action: PayloadAction<SetNextInquiryPayload>) => {
      // need to cast this for some reason to avoid
      // 'Type instantiation is excessively deep and possibly infinite' errors
      (state as VerifyWithPersonaState).nextInquiry = action.payload.inquiry;
    },
  },
});

export const { setNextInquiry } = actions;
export default reducer;
